class stickyProduct extends HTMLElement {
    constructor() {
        super();

        this.sticky = document.getElementById('sticky-product');
        const resizeObserver = new ResizeObserver(entries => this.checkHeight.bind(this));
        resizeObserver.observe(this.sticky);
    }

    checkHeight() {
        if (document.getElementById('sticky-product').classList.contains('in-sticky')) {
            var sticky_single = setInterval(function() {
                var height_sticky = document.getElementById('sticky-product').offsetHeight;
                document.getElementsByTagName("body")[0].style.paddingBottom = height_sticky;
                clearInterval(sticky_single);
            }, 100);
        }
    }

    connectedCallback() {
        this.stickyBounds = {};

        this.sticky = document.getElementById('sticky-product');
        this.currentScrollTop = 0;

        this.onScrollHandler = this.onScroll.bind(this);

        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.stickyBounds = entries[0].intersectionRect;
            observer.disconnect();
        });
        observer.observe(this.sticky);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.stickyBounds.bottom) {
            requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.stickyBounds.bottom) {
            requestAnimationFrame(this.hide.bind(this));
        }
        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.sticky.classList.remove('in-sticky');
        document.getElementsByTagName("body")[0].classList.remove('sticky-page');
    }

    reveal() {
        this.sticky.classList.add('in-sticky');
        document.getElementsByTagName("body")[0].classList.add('sticky-page');
        this.checkHeight();
    }
}

customElements.define('sticky-product', stickyProduct);